<template>
  <d-popup v-slot="{ close }" v-bind="$attrs" @closed="removeHash">
    <div class="d-callMe__form">
      <div class="d-callMe__top">
        <div class="d-callMe__title">Записаться <br  /> на экскурсию</div>
        <div class="d-callMe__subtitle">Оставьте Ваши контакты и наши менеджеры свяжутся с Вами.</div>
        <img src="/assets/blueant/assets/img/d/trip_popup.png" class="d-callMe__bg">
      </div>
      <d-trip-form :action-url="actionUrl" :projects="projects" :politics-link="politicsLink" :type="type" @success="close"/>
    </div>
  </d-popup>
</template>

<script>
import DPopup from '@components/molecules/DPopup.vue';
import DTripForm from "@components/organisms/DTripForm.vue";

export default {
  name: "DTripFormPopup",
  components: {
    DPopup,
    DTripForm
  },
  props: {
    actionUrl: {
      type: String,
      required: true,
      default: '',
    },
    leadUrl: {
      type: [String, Boolean],
      default: false,
    },
    props: {
      type: [Object, Boolean, String],
      default: false,
    },
    politicsLink: {
      type: String,
      required: true,
      default: '',
    },
    projects: {
      type: Array,
      default: () => []
    },
    mod: {
      type: String,
      required: false,
      default: '',
    },
    type: {
      type: String,
      default: 'trip',
    }
  },
  methods: {
    removeHash() {
      if (window.location.hash.match(/excursion/)) {
        const url = new URL(location.href);
        url.hash = '';
        history.pushState(null, '', url);
      }
      console.log('remove hash')
    }
  }
}
</script>



<style scoped>

</style>